"use strict";

import _objectSpread from "/home/runner/work/scratchlinkcodes/scratchlinkcodes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/home/runner/work/scratchlinkcodes/scratchlinkcodes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/runner/work/scratchlinkcodes/scratchlinkcodes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import * as s from "react";

function o(_ref) {
  var e = _ref.children,
      _ref$render = _ref.render,
      t = _ref$render === void 0 ? "idle" : _ref$render,
      _ref$unmount = _ref.unmount,
      i = _ref$unmount === void 0 ? "never" : _ref$unmount,
      n = _objectWithoutProperties(_ref, ["children", "render", "unmount"]);

  var _s$useState = s.useState(!n.hidden || t === "always"),
      _s$useState2 = _slicedToArray(_s$useState, 2),
      u = _s$useState2[0],
      c = _s$useState2[1];

  return s.useEffect(function () {
    !n.hidden || t === "always" ? c(!0) : t === "idle" ? ("requestIdleCallback" in window ? requestIdleCallback : setTimeout)(function () {
      return c(!0);
    }) : i === "always" ? c(!1) : i === "idle" && ("requestIdleCallback" in window ? requestIdleCallback : setTimeout)(function () {
      return c(!1);
    });
  }, [n.hidden, t, i]), s.createElement("div", _objectSpread({}, n), u ? e : null);
}

import * as l from "react";

function d(e) {
  var t = l.useRef();
  return l.useEffect(function () {
    t.current = e;
  }), t.current;
}

function f(e, t) {
  var i = l.useState(),
      _i = _slicedToArray(i, 2),
      n = _i[0],
      u = _i[1],
      c = l.useMemo(function () {
    return n ? e.indexOf(n) : -1;
  }, [n, e]),
      r = d(c);

  return l.useEffect(function () {
    if (e.length === 0) {
      u(void 0);
      return;
    }

    if (!(n === null || n && e.includes(n))) {
      if (typeof r == "number" && r >= 0 && (e[r] || e[r - 1])) {
        u(e[r] || e[r - 1]);
        return;
      }

      t !== null && u(t && e.includes(t) ? t : e[0]);
    }
  }, [t, r, n, u, e]), i;
}

export { o as TabPanel, f as useTabs };